import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "Actions";
import PhoneNumberForm from "./two_factor/PhoneNumberForm";
import PhoneCodeForm from "./two_factor/PhoneCodeForm";
import SimpleSignInForm from "./two_factor/SimpleSignInForm";

import {
  TWO_FACTOR_AUTH_STATE_REQUIRED,
  TWO_FACTOR_AUTH_STATE_ENTER_CODE,

} from "Constants/redux";

class SignIn extends Component {
  constructor() {
    super();
    this.state = {
      phoneNumber: '',
      shouldRememberDevice: false,
    }
  }

  fieldChanged = ( event ) => {
    this.setState( { [event.target.name]: event.target.value } )
  };

  handleHitSmsApi = () => {
    const { email, phone, hitSmsApi } = this.props;
    hitSmsApi(email, phone)
  };

  render() {
    const {
      twoFactorAuthState, fieldChanged, phone, sendingSms, resetTwoFactor, loading,
      email, password, errors, forcedSignOut, forcedNewTabSignOut, clearSignedInOnOtherDevice, hitSmsApi,
      loginUser
    } = this.props;
    const requiresPhone = twoFactorAuthState === TWO_FACTOR_AUTH_STATE_REQUIRED;
    const requiresCode = twoFactorAuthState === TWO_FACTOR_AUTH_STATE_ENTER_CODE;

    return (
      requiresPhone ?
        <PhoneNumberForm
          fieldChanged={fieldChanged}
          phone={phone}
          email={email}
          sendingSms={sendingSms}
          resetTwoFactor={resetTwoFactor}
          hitSmsApi = {hitSmsApi}
        />
        : requiresCode ?
          <PhoneCodeForm
            resetTwoFactor={resetTwoFactor}
            loading={loading}
            hitSmsApi={hitSmsApi}
            email={email}
            password={password}
            twoFactorAuthState={twoFactorAuthState}
            handleHitSmsApi = {this.handleHitSmsApi}

          />
          :
          <SimpleSignInForm
            email={email}
            password={password}
            errors={errors}
            forcedSignOut={forcedSignOut}
            forcedNewTabSignOut={forcedNewTabSignOut}
            clearSignedInOnOtherDevice={clearSignedInOnOtherDevice}
            loginUser={loginUser}
          />
    );
  }
}

SignIn.propTypes = {
  loginUser: PropTypes.func.isRequired,
  fieldChanged: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired
};

const mapStateToProps = state => {
  const {
    email,
    password,
    errors,
    loading,
    forcedSignOut,
    forcedNewTabSignOut,
    twoFactorAuthState,
    phone,
    isValidatingPassword,
    passwordIsValid,
    sendingSms
  } = state.auth;

  return {
    email,
    password,
    errors,
    loading,
    forcedSignOut,
    forcedNewTabSignOut,
    twoFactorAuthState,
    phone,
    isValidatingPassword,
    passwordIsValid,
    sendingSms
  };
};

export default connect( mapStateToProps, actions )( SignIn );
